/**
 * Header school / site label (PA2-08). Prefer outlet name until BE adds a dedicated field.
 */
export function schoolDisplayName({ selectedOutlet, parentOutlet, dashboardOutlet } = {}) {
	return (
		selectedOutlet?.name ||
		parentOutlet?.name ||
		dashboardOutlet?.name ||
		'School'
	);
}

export function familyAccountHeading(schoolName) {
	return `${schoolName || 'School'} · Family account`;
}
